import { combineReducers } from 'redux'

import arquivosPrestacaoContasAnual from './arquivosPrestacaoContasAnual'

export default combineReducers({ arquivosPrestacaoContasAnual })
